/**
 * Tab-close helper for MAT "view as school" impersonation.
 *
 * MAT impersonation opens in a new browser tab (see features/groups/viewAs/viewAs.tsx,
 * which uses window.open WITHOUT noopener — that is what allows window.close() below to
 * work). Ending impersonation or signing out of a viewed-as school closes only that tab
 * and leaves the original Summit (MAT) tab signed in. See CI 52102.
 */

/**
 * Close the current tab, falling back to a full navigation if the browser blocks it.
 * window.close() silently no-ops when the tab wasn't script-opened (e.g. refreshed or
 * opened directly), so if we're still executing shortly after, navigate to `fallbackUrl`.
 */
export function closeTabOrFallback(fallbackUrl: string): void {
	window.close();
	window.setTimeout(() => window.location.assign(fallbackUrl), 150);
}
